import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import {
  Card,
  Stack,
  Inline,
  Input,
  Button
} from '@leroy-merlin-br/backyard-react-ui'

import { DropDown } from 'lmcv/components/DropDown'
import * as relationship from 'lmcv/services/relationship'

import { Header } from './components/Header'
import * as S from './styled'

function ProfilePending ({ data, handleDropDown }) {
  const {
    customerName,
    projectName,
    status,
    remainingWeeks,
    inviteUrl,
    id
  } = data

  const { handleSubmit, register, errors } = useForm({ mode: 'onBlur' })

  const [isOnClipboard, setIsOnClipboard] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isSentToEmail, setIsSentToEmail] = useState(false)

  const onCopyToClip = () => {
    setIsOnClipboard(true)
    setTimeout(() => setIsOnClipboard(false), 2000)
  }

  const onSendInvite = async ({ email }) => {
    setIsLoading(true)

    const payload = {
      relationshipId: id,
      guestEmail: email
    }

    const handleSuccess = () => {
      setIsSentToEmail(true)
      setTimeout(() => setIsSentToEmail(false), 2000)
    }

    const handleError = err => {
      console.error(err)
    }

    await relationship
      .sendInvite(payload)
      .then(handleSuccess)
      .catch(handleError)
      .finally(() => setIsLoading(false))
  }

  return (
    <Card>
      <S.Menu>
        <DropDown>
          <DropDown.Item text="Excluir cliente" onClick={handleDropDown} />
        </DropDown>
      </S.Menu>

      <S.Content>
        <Header
          customerName={customerName}
          projectName={projectName}
          projectStatus={status}
        />

        <S.Box>
          <S.BoxItem>
            <S.BoxTitle>Tempo previsto</S.BoxTitle>
            <div>
              <S.BoxTextWeeksNumber>{remainingWeeks}</S.BoxTextWeeksNumber>
              <S.BoxTextWeeks>Semanas</S.BoxTextWeeks>
            </div>
            <S.BoxTextInfo>
              A contagem iniciará após seu cliente aceitar o convite
            </S.BoxTextInfo>
          </S.BoxItem>

          <S.BoxItem>
            <S.BoxTitle>Reenviar convite</S.BoxTitle>
            <S.Form onSubmit={handleSubmit(onSendInvite)}>
              <Stack>
                <Inline justify="left" align="bottom">
                  <Input
                    type="text"
                    label="Compartilhar link"
                    defaultValue={inviteUrl}
                    readOnly
                  />
                  <CopyToClipboard text={inviteUrl} onCopy={onCopyToClip}>
                    <Button type="button" size="kilo">
                      {isOnClipboard ? 'Copiado!' : 'Copiar'}
                    </Button>
                  </CopyToClipboard>
                </Inline>

                <Inline justify="left" align="center">
                  <Input
                    name="email"
                    label="Enviar link por e-mail"
                    ref={register({ required: 'Insira um e-mail' })}
                    isInvalid={Boolean(errors?.email?.message)}
                    validationHint={
                      errors?.email?.message
                        ? errors?.email?.message
                        : 'Ex: E-mail do cliente'
                    }
                  />
                  <Button type="submit" size="kilo" isLoading={isLoading}>
                    {isSentToEmail ? 'Enviado!' : 'Enviar'}
                  </Button>
                </Inline>
              </Stack>
            </S.Form>
          </S.BoxItem>
        </S.Box>
      </S.Content>
    </Card>
  )
}

export default ProfilePending
